export default "__VITE_ASSET__C8g58qs3__"